function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 237.109,
    x2: 419.106,
    y1: 223.219,
    y2: 146.89,
    gradientTransform: "matrix(1 0 0 -1 0 513)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#249361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3ecf8e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.6 501c-12.9 16.3-39.2 7.4-39.5-13.4L253.6 183h204.8c37.1 0 57.8 42.8 34.7 71.9z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 245.829,
    x2: 328.829,
    y1: 411.681,
    y2: 255.438,
    gradientTransform: "matrix(1 0 0 -1 0 513)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.6 501c-12.9 16.3-39.2 7.4-39.5-13.4L253.6 183h204.8c37.1 0 57.8 42.8 34.7 71.9z",
    style: {
      fill: "url(#b)",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.4 11c12.9-16.3 39.2-7.4 39.5 13.4l2 304.5H53.7c-37.1 0-57.8-42.8-34.7-71.9z",
    style: {
      fill: "#3ecf8e"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupabase);
export default __webpack_public_path__ + "static/media/supabase.f8dca80f16b5354445fcc1b6408ea539.svg";
export { ForwardRef as ReactComponent };